module.exports = __webpack_public_path__ + "static/media/Jomar.342cc868.png";